// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carrer-level[data-v-1ad3fd9e]{display:inline-block;border-radius:.25rem;line-height:1.72;text-align:center;--text-opacity:1;color:#171717;color:rgba(23,23,23,var(--text-opacity));--border-opacity:1;border-color:#a3a3a3;border-color:rgba(163,163,163,var(--border-opacity));border-width:1px;font-size:1rem;margin-bottom:1rem;padding-left:.5rem;padding-right:.5rem;font-weight:300}", ""]);
// Exports
module.exports = exports;
